import {
  SuccessStatusIcon,
  WarningStatusIcon,
  ErrorStatusIcon,
  OutputStatusIcon,
  Draft,
  Open,
  Uncollectible,
  Void,
} from 'components/SVG';

export const infoCardStatus: Record<string, any> = {
  success: {
    Icon: SuccessStatusIcon,
    bgColor: '#e2f3e8',
    borderColor: '#62af83',
  },
  warning: {
    Icon: WarningStatusIcon,
    bgColor: '#FEF7F1',
    borderColor: '#F4821F',
  },
  error: {
    Icon: ErrorStatusIcon,
    bgColor: '#FFF4F4',
    borderColor: '#EF5251',
  },
  info: {
    Icon: null,
    bgColor: '#ECEFFE',
    borderColor: '#6267AC',
  },
};
export const statusConfigByStatusTag: Record<string, any> = {
  success: {
    Icon: SuccessStatusIcon,
    bgColor: '#FFFFFF',
    borderColor: '#EEEEEE',
  },
  warning: {
    Icon: WarningStatusIcon,
    bgColor: '#FEF7F1',
    borderColor: '#F4821F',
  },
  error: {
    Icon: ErrorStatusIcon,
    bgColor: '#FFF4F4',
    borderColor: '#EF5251',
  },
  output: {
    Icon: OutputStatusIcon,
    bgColor: '#ECEFFE',
    borderColor: '#6267AC',
  },
  draft: {
    Icon: Draft,
    bgColor: '#F4821F',
    borderColor: '#F4821F',
  },
  open: {
    Icon: Open,
    bgColor: '#F4821F',
    borderColor: '#F4821F',
  },
  uncollectible: {
    Icon: Uncollectible,
    bgColor: '#EF5251',
    borderColor: '#EF5251',
  },
  void: {
    Icon: Void,
    bgColor: '#EF5251',
    borderColor: '#EF5251',
  },
  info: {
    Icon: null,
    bgColor: '#ECEFFE',
    borderColor: '#6267AC',
  },
};
